import { inject, Injectable } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { User } from '@rd/types';
import { from } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AuthActionTypes } from '../auth/store/actions/auth.actions';

@Injectable()
export class UnleashInitEffects {
  actions$ = inject(Actions);
  unleashService = inject(UnleashService);

  unleashUserLoginInit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGIN_USER),
        switchMap(({ payload }: { payload: User }) =>
          from(
            this.unleashService.unleash.updateContext({
              userId: payload.sub,
            }),
          ),
        ),
        tap(() => {
          // Force an update event after context change. The SDK does not
          // emit UPDATE on 304 responses, but consumers of user-scoped
          // flags need to re-evaluate after the userId changes.
          this.unleashService.unleash.emit('update');
        }),
      ),
    {
      dispatch: false,
    },
  );
}
